<template>
  <v-dialog v-model="show" scrollable max-width="650">
    <v-card v-if="stop" class="rounded" dark color="#406d59">
      <v-card-title class=" pa-2 pa-md-3 justify-center" style="font-family: 'Oswald', sans-serif !important;font-weight: bold !important;">
        {{ stop.name }}
      </v-card-title>
      <v-card-subtitle
        class="d-flex align-center  ma-0 pa-2 pa-md-3"
      >
        <v-avatar :color="stop.routeColor" size="32" class="mx-1">
          <img src="../assets/dpvbusstop.png" alt="Stop" />
        </v-avatar>
        <div class="mx-1">
          <p class="ma-0">{{ stop.address }}</p>
          <p class="ma-0" :style="`color: #bfc1ad;`">
            Next bus {{ timeToNextBus }}
          </p>
        </div>
      </v-card-subtitle>
      <v-card-text
        class=" pa-2 pa-md-3"
        style="max-height: 650px;"
      >
        <v-row v-for="(day, d) in nextWeek" :key="d" no-gutters>
          <v-col>
            <span>{{ day }}</span>
            <div class="d-flex overflow-x-auto" :class="$vuetify.breakpoint.smAndDown ? 'no-scroll' : 'scroll-x'">
              <div class="d-flex">
                <template
                  v-for="(time, t) in findDaySchedule(stop.schedule, day)"
                >
                  <v-chip
                    v-if="d === 0 && t === upcoming"
                    ref="upcoming"
                    :key="t"
                    color="#bfc1ad"
                    class="ma-1"
                  >
                    {{ time }}
                  </v-chip>
                  <v-chip v-else :key="t" color="white" outlined class="ma-1">
                    {{ time }}
                  </v-chip>
                </template>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment'
import _ from 'lodash/util'

export default {
  name: 'StopPopUp',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    stop: {
      type: Object,
      default: null
    },
    routeColor: {
      type: String,
      default: null
    }
  },
  data: () => ({}),
  computed: {
    show: {
      get: function() {
        return this.value
      },
      set: function(value) {
        this.$emit('input', value)
      }
    },
    nextWeek: function() {
      return _.range(7).map(i =>
        moment()
          .add(i, 'days')
          .format('dddd')
      )
    },
    todaySchedule: function() {
      return this.findDaySchedule(this.stop.schedule, this.nextWeek[0])
    },
    upcoming: function() {
      return this.findUpcomingStopTime(this.todaySchedule)
    },
    timeToNextBus: function() {
      let next = moment(this.todaySchedule[this.upcoming], 'hh:mm A')
      return next.fromNow()
    }
  },
  updated: function() {
    this.$refs.upcoming[0].$el.scrollIntoView({
      behaviour: 'smooth',
      block: 'center',
      inline: 'center'
    })
  },
  methods: {
    findDaySchedule: function(schedules, day) {
      /**
       * Returns a day's schedule from an Object of named schedules
       */
      let daySchedule = Object.keys(schedules).findIndex(d => d === day)
      if (daySchedule < 0) daySchedule = 0
      return Object.values(schedules)[daySchedule]
    },
    findUpcomingStopTime: function(schedule) {
      /**
       * Returns the index of the upcoming stop time in an schedule array
       */
      // Get the time differences for schedule times with today's date
      let diffs = schedule.map(time =>
        moment(time, 'hh:mm A').diff(moment(), 'minutes')
      )
      // Find which one is closer forward in time
      let upcoming = Math.min(...diffs.filter(d => d >= 0))
      return diffs.findIndex(d => d === upcoming)
    }
  }
}
</script>

<style>
.rounded {
  border-radius: 12px !important;
}
.no-scrollbar {
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
}
.no-scrollbar::-webkit-scrollbar {
  display: none;
}
/* Contenedor general del scroll */
.scroll-x {
  display: flex;
  overflow-x: auto !important;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: #bfc1ad #406d59; /* thumb y track (para Firefox) */
}

/* Chrome, Edge, Safari */
.scroll-x::-webkit-scrollbar {
 /* height: 8px;  grosor de la barra horizontal */
}

/* Fondo del track (zona gris detrás de la barra) */
.scroll-x::-webkit-scrollbar-track {
  background: #406d59; /* color de fondo del track */
 /* border-radius: 10px;*/
}

/* La barra misma (thumb) */
.scroll-x::-webkit-scrollbar-thumb {
  background-color: #bfc1ad; /* color principal de la barra */
  /*border-radius: 10px;*/
  border: 2px solid #406d59; /* opcional: genera efecto "hueco" */
}

/* Hover sobre la barra */
.scroll-x::-webkit-scrollbar-thumb:hover {
  background-color: #bfc1ad; /* color al pasar el cursor */
}
</style>
